import { AuthUser } from "../models/AuthUser";

const KEY_LOCALSTORAGE_USER: string = "UserToken";

class UserStorage {

    /* Retrieves the current user from the local storage and returns it. */
    getCurrentUser(): AuthUser | null {

        var storedValue: string | null = localStorage.getItem(KEY_LOCALSTORAGE_USER);
        if (storedValue == null)
        {
            return null;
        }

        var authUser: AuthUser = JSON.parse(storedValue);
        return authUser;
    }

    /* Persits the current logged in user within the local Storage */
    setUser(user: AuthUser): void {

        var storedValue: string = JSON.stringify(user);
        localStorage.setItem(KEY_LOCALSTORAGE_USER, storedValue);
    }

    /* Removes the current logged in user from the local storage */
    destroy(): void {

        localStorage.removeItem(KEY_LOCALSTORAGE_USER);
    }
}
export default new UserStorage();